import React, { useEffect, useLayoutEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setGlobalLoader } from "../../../redux/slices/globalLoader";
import { setTitle } from "../../../utils/commonfunction";
import UserFooter from "./footer";
import UserHeaderDark from "./headerDark";

function UserAuthLayout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  window.navigate_ = navigate;

  return (
    <div className="site-bg">
      <UserHeaderDark />
      <div className="inner-wraper pt-[75px]">
        <Outlet />
      </div>
      <UserFooter />
    </div>
  );
}

export default UserAuthLayout;
